import { Component, inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MenuService } from '../../menu.service';
import { WebdokuService } from '../../../web-doku/webdoku.service';
import { LdwRouterService } from '../../../route/ldw-router.service';
import { InfoService } from '../../../shared/services/info.service';
import { BookmarkService } from '../../../bookmarks/bookmark.service';
import { UserBottomSheetComponent } from './user-bottom-sheet/user-bottom-sheet.component';
import { InfoBottomSheetComponent } from './info-bottom-sheet/info-bottom-sheet.component';
import { NavigationBaseComponent } from '../navigation-base/navigation-base.component';
import { MenuCommand } from '../../../shared/models/menu-command';
import { HttpLoadingService } from '../../http-loading.service';
import { SettingsService } from '../../../shared/settings/settings.service';
import { OAuthService, OAuthStorage } from 'angular-oauth2-oidc';
import { UserInformationService } from '../../user-information.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'ldw-bottom-navigation',
    templateUrl: './bottom-navigation.component.html',
    styleUrls: ['./bottom-navigation.component.css'],
    standalone: false
})
export class BottomNavigationComponent extends NavigationBaseComponent {
  menuService: MenuService;
  webDokuService: WebdokuService;
  bookmarkService: BookmarkService;
  infoService: InfoService;
  httpLoadingService: HttpLoadingService;
  settingsService: SettingsService;
  userInformationService: UserInformationService;
  private routerService = inject(LdwRouterService);
  private bottomSheet = inject(MatBottomSheet);

  constructor() {
    const menuService = inject(MenuService);
    const webDokuService = inject(WebdokuService);
    const bookmarkService = inject(BookmarkService);
    const infoService = inject(InfoService);
    const httpLoadingService = inject(HttpLoadingService);
    const settingsService = inject(SettingsService);
    const userInformationService = inject(UserInformationService);

    super(
      menuService,
      webDokuService,
      bookmarkService,
      infoService,
      httpLoadingService,
      settingsService,
      userInformationService
    );

    this.menuService = menuService;
    this.webDokuService = webDokuService;
    this.bookmarkService = bookmarkService;
    this.infoService = infoService;
    this.httpLoadingService = httpLoadingService;
    this.settingsService = settingsService;
    this.userInformationService = userInformationService;
  }

  public get backButtonVisible(): boolean {
    return this.routerService.canNavigateBack;
  }

  public get overflowButtonVisible(): boolean {
    return this.webDokuService.isWebDokuSelected;
  }

  public backButtonClicked() {
    this.routerService.navigateBack();
  }

  openInfoBottomSheet(): void {
    this.bottomSheet.open(InfoBottomSheetComponent);
  }

  openUserBottomSheet(): void {
    this.bottomSheet.open(UserBottomSheetComponent);
  }
}
